<template>
  <div class="child-route-wrapper">
    <h1 class="registration-form-title">
      Set your launch date
    </h1>
    <b-form
      class="registration-form-wrapper"
      @submit.prevent="onSubmit"
    >
      <b-form-group
        class="registration-input-group"
        label="When would you like to go live?"
        label-for="launch-date-select"
        label-class="registration-label"
      >
        <b-dropdown
          id="launch-date-select"
          class="custom-dropdown w-100"
          block
          variant="outline-secondary"
        >
          <template #button-content>
            <div class="d-flex align-items-center justify-content-between w-100">
              <span>{{ selectedLaunchDate || 'Choose launch date' }}</span>
              <dropdown-icon />
            </div>
          </template>
          <b-dropdown-item
            v-for="option in launchDateOptions"
            :key="option"
            @click="selectedLaunchDate = option"
          >
            {{ option }}
          </b-dropdown-item>
        </b-dropdown>
      </b-form-group>
      <b-button
        class="registration-button"
        type="submit"
        :disabled="isLoading"
      >
        {{ isLoading ? 'Signing up...' : isRegistrationOtpEnabled ? 'Next' : 'Sign up' }}
      </b-button>
    </b-form>
  </div>
</template>

<script>
import {
  BForm, BFormGroup, BButton, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import { AUTH_REGISTER_V2_CHILDREN } from '@/router/routes/utils'
import DropdownIcon from '@/@core/assets/svg-components/DropdownIcon.vue'
import { useFormFields } from '@/views/apps/authentication-v2/useFormFields'
import analytics from '@core/utils/analytics'
import constants, { FLAG_CONSTANTS } from '@/constants'
import { computed, watch } from '@vue/composition-api'
import { registerAction } from '@/views/apps/authentication-v2/child-routes/registerAction'
import store from '@/store'

export default {
  name: 'SetLaunchDate',
  components: {
    BForm,
    BFormGroup,
    BButton,
    BDropdown,
    BDropdownItem,
    DropdownIcon,
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    isRegistrationOtpEnabled() {
      return store.state.flags[FLAG_CONSTANTS.REGISTRATION_FLOW_V2]
    },
  },
  setup() {
    const { selectedLaunchDate } = useFormFields()

    watch(selectedLaunchDate, () => {
      analytics.track(constants.TRACKS.ACTIONS.REGISTER_V2.LAUNCH_DATE_SELECT, {
        formData: {
          selectedLaunchDate: selectedLaunchDate.value,
        },
      })
    })

    const launchDateOptions = [
      'Within this week',
      'Within the next 2 weeks',
      'Within the next 4 weeks',
    ]

    // Set the default value to the first option in the array
    if (!selectedLaunchDate.value) {
      selectedLaunchDate.value = launchDateOptions[0]
    }

    const filteredLaunchDateOptions = computed(() => launchDateOptions.filter(option => option !== selectedLaunchDate.value))

    return {
      selectedLaunchDate,
      launchDateOptions,
      filteredLaunchDateOptions,
    }
  },
  mounted() {
    analytics.track(constants.TRACKS.ACTIONS.REGISTER_V2.LAUNCH_DATE_VIEW)
  },
  methods: {
    async onSubmit() {
      analytics.track(constants.TRACKS.ACTIONS.REGISTER_V2.LAUNCH_DATE_NEXT_CLICK, {
        formData: {
          selectedLaunchDate: this.selectedLaunchDate,
        },
      })
      if (!this.isRegistrationOtpEnabled) {
        // When the flag is OFF, navigate to SET_CREDENTIALS without calling registerAction
        this.$router.push({ name: AUTH_REGISTER_V2_CHILDREN.SET_CREDENTIALS }).catch(() => {})
      } else {
        this.isLoading = true
        try {
          await registerAction({ router: this.$router })
        } finally {
          this.isLoading = false
        }
        this.$router.push({ name: AUTH_REGISTER_V2_CHILDREN.CONFIRM }).catch(() => {})
      }
    },
  },
}
</script>

<style lang="scss">
@import '../common-styles.scss';

.observer-wrapper {
  width: 100%;
}

.custom-dropdown {
  .btn {
    height: 48px;
    background-color: white !important;
    color: #212529 !important;
    border: 1px solid #ced4da !important;
    font-size: 20px;
    font-weight: 400;
    line-height: 30px;
    text-align: left;
    padding: 8px 16px;
    box-shadow: none !important;

    &::after {
      display: none;
    }
  }

  .dropdown-menu {
    width: 100%;
    margin-top: 0;

    .dropdown-item {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      padding: 7px 24px;
    }
  }
}

@media screen and (max-width: 660px) {
  .custom-dropdown {
    .btn {
      height: 38px;
      font-size: 16px;
      line-height: 24px;
      padding: 6px 12px;
    }
  }
}

.registration-button {
  width: 100%;
  height: 48px;
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  padding: 8px 16px;
  border-radius: 0.25rem;
  border: none;
  background-color: #7367f0;
  color: #fff;
  cursor: pointer;
}

.registration-button:hover {
  background-color: #5e50ec;
}

@media screen and (max-width: 660px) {
  .registration-button {
    height: 38px;
    font-size: 16px;
    line-height: 24px;
    padding: 6px 12px;
  }
}
</style>
